/* eslint-disable no-undef */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import 'signalr';


class SignalR extends PureComponent {
  constructor(props) {
    super(props);

    this.retryCounter = 1;
    this.connection = null;
    this.hub = null;
  }

  componentDidMount() {
    this.connection = $.hubConnection(this.props.connectionHub);
    this.connection.qs = { access_token: this.props.accessToken };
    this.hub = this.connection.createHubProxy('waiterNotificationHub');

    this.hub.on('orderUpdated', this.props.orderUpdated);

    this.startConnection();

    this.connection.reconnected(() => {
      console.log('SignalR reconnected');
      this.props.setSignalRState(true);
      this.hub.invoke('SubscribeWaiter');
      this.retryCounter = 1;
    });

    this.connection.connectionSlow(() => {
      console.log('SignalR connection slow');
      this.props.setSignalRState(false);

      setTimeout(() => this.startConnection(), 60000 * this.retryCounter);
    });

    this.connection.disconnected(() => {
      console.log('SignalR disconnected');
      this.props.setSignalRState(false);

      this.retryCounter = this.retryCounter + 1;

      setTimeout(() => this.startConnection(), 10000 * this.retryCounter);
    });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.accessToken && this.hub) {
      this.connection.qs = { access_token: newProps.accessToken };
    }
  }

  componentWillUnmount() {
    if (this.connection) {
      this.connection.stop();
      this.connection = null;
    }

    if (this.reconnectInterval) {
      clearInterval(this.reconnectInterval);
      this.reconnectInterval = null;
    }
  }

  startConnection() {
    try {
      this.connection.start({ transport: ['webSockets', 'longPolling'] })
        .then(
          () => {
            console.log('SignalR Connection established');

            this.retryCounter = 1;
            this.props.setSignalRState(true);
            this.hub.invoke('SubscribeWaiter');
          },
          (err) => {
            console.error('SignalR Connection Error: ', err);

            this.retryCounter = this.retryCounter + 1;

            setTimeout(() => this.startConnection(), 60000 * this.retryCounter);
          });
    } catch (error) {
      console.error('SignalR Connection Error Exception: ', error);
      setTimeout(() => this.startConnection(), 60000 * this.retryCounter);
    }

  }

  render() {
    return <span />;
  }
}

SignalR.propTypes = {
  connectionHub: PropTypes.string.isRequired,
  accessToken: PropTypes.string.isRequired,
  orderUpdated: PropTypes.func.isRequired,
  setSignalRState: PropTypes.func.isRequired,
};

export default SignalR;
